<section class="nopad">
    <div class="container-fluid register">
        <div class="row text-center">
            <div class="col-md-3 register-left">
                <div class="col-md-12 nopad">
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/AICTELogo.png" alt="Logo" style="margin-left: 25px;"></a>
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/SLALogo.png" alt="Logo"></a>
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/Parakhlogo.png" alt="Logo" style="height: 47px; margin-left: -20px;"></a>
                </div>
                <div class="col-md-12 nopad leftSection">
                    <img class="IconImg" src="https://image.ibb.co/n7oTvU/logo_white.png" alt="" />
                    <h3>Welcome</h3>
                    <p>You are a few seconds away from creating your account!</p>
                    <p>Already a user?</p>
                    <a [routerLink]="['/login']" class="mt-3 registerBtn loginBtn">LOGIN</a>
                </div>
            </div>
            <div class="col-md-9 register-right">
                <form [formGroup]="registerForm" (ngSubmit)="onSubmit(registerForm.value)" class="registerFormContainer">
                    <h2 class="registerHeading">Register Yourself</h2>
                    <div class="row">

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <mat-select placeholder="Institute" (selectionChange)="onInstituteChange($event)" formControlName="institute_type">
                                <mat-option *ngFor="let institute of institutes" [value]="institute.id">{{institute.organization_type}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="registerForm.controls.institute_type.errors && (registerForm.controls.institute_type.touched || registerForm.controls.institute_type.dirty)">
                                Required</mat-error>
                        </mat-form-field>

                        <div *ngIf="aicteInstBool" class="col-6" style="text-align: left;">
                            <button type="button" mat-raised-button class="mat-elevation-z6 get-detail-btn" (click)="PIDSelect()">Select Institute
                                PId</button>
                        </div>
                            
                        <mat-form-field *ngIf="aicteInstBool" [floatLabel]="'never'" class="col-6">
                            <input matInput type="text" placeholder="Institute PID" formControlName="institute_permanent_id" [readonly]="aicteInstBool" autocomplete="new-password" maxlength="100">
                            <mat-error *ngIf="registerForm.controls.institute_permanent_id.errors">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6" *ngIf="!aicteInstBool">
                            <mat-select placeholder="Have an AISHE Code" (selectionChange)="onCodeSelection($event)">
                                <mat-option value="Yes">Yes</mat-option>
                                <mat-option value="No">No</mat-option>
                            </mat-select>
                        </mat-form-field>
                            
                        <mat-form-field *ngIf="aisheBool && !aicteInstBool" [floatLabel]="'never'" class="col-6">
                            <input matInput type="text" placeholder="Enter AISHE Code" formControlName="aishe_code" autocomplete="new-password" maxlength="100">
                        </mat-form-field>

                        <div *ngIf="aisheBool && !aicteInstBool" class="col-6" style="text-align: left;">
                            <button type="button" (click)="getAisheDetails()" mat-raised-button class="mat-elevation-z6 get-detail-btn" >
                                Get Details</button>
                        </div>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input title="{{registerForm.controls.institute_name.value}}" matInput type="text" placeholder="Institute Name" formControlName="institute_name" [readonly]="aicteInstBool || aisheBool" autocomplete="new-password">
                            <mat-error *ngIf="registerForm.controls.institute_name.errors">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input title="{{registerForm.controls.institute_address.value}}" matInput type="text" placeholder="Institute Address" formControlName="institute_address" [readonly]="aicteInstBool || aisheBool" autocomplete="new-password">
                            <mat-error *ngIf="registerForm.controls.institute_address.errors">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6" *ngIf="!aisheBool">
                            <div *ngIf="aicteInstBool">
                                <input title="{{registerForm.controls.inst_type.value}}" matInput type="text" placeholder="Institute Type" formControlName="inst_type" readonly autocomplete="new-password">
                            </div>
                            <div *ngIf="!aicteInstBool">
                                <mat-select placeholder="Institute Type" formControlName="inst_type">
                                    <mat-option *ngFor="let element of instTypes" [value]="element.inst_type">{{element.inst_type}}</mat-option>
                                    <!-- <mat-option value="Private">Private</mat-option> -->
                                </mat-select>
                            </div>                        
                            <mat-error *ngIf="registerForm.controls.inst_type.errors">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <div *ngIf="aicteInstBool || aisheBool">
                                <input type="text" placeholder="Institute State" matInput formControlName="state" [readonly]="aicteInstBool || aisheBool" autocomplete="new-password">
                            </div>
                            <div *ngIf="!aicteInstBool && !aisheBool">
                                <mat-select placeholder="Institute State" (selectionChange)="onSelectState($event)" formControlName="state">
                                    <mat-option *ngFor="let state of states" [value]="state['state']">{{state.state}}</mat-option>
                                </mat-select>
                            </div>
                            <mat-error *ngIf="registerForm.controls.state.errors">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <div *ngIf="aicteInstBool || aisheBool">
                                <input type="text" matInput placeholder="Institute City" formControlName="city" [readonly]="aicteInstBool || aisheBool" autocomplete="new-password">
                            </div>
                            <div *ngIf="!aicteInstBool && !aisheBool">
                                <mat-select placeholder="Institute city" formControlName="city">
                                    <mat-option *ngFor="let city of district" [value]="city['name']">{{city.name}}</mat-option>
                                </mat-select>
                            </div>
                                <mat-error *ngIf="registerForm.controls.city.errors">
                                Required</mat-error>
                        </mat-form-field>
                        
                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input matInput placeholder="HOI Official Email" formControlName="principalEmail" [readonly]="aicteInstBool || aisheBool" autocomplete="new-password" maxlength="100">
                            <mat-error *ngIf="registerForm.controls.principalEmail.errors?.required">Email is required</mat-error>
                            <mat-error *ngIf="registerForm.controls.principalEmail.errors?.pattern">Please enter valid email address</mat-error>
                        </mat-form-field>
                        
                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input matInput type="text" placeholder="HOI Official Mobile" (keypress)="checkNumber($event)" formControlName="principalMobile" maxlength="10" [readonly]="aicteInstBool || aisheBool" autocomplete="new-password">
                            <mat-error *ngIf="registerForm.controls.principalMobile.errors">
                                Please enter a valid mobile number.</mat-error>
                        </mat-form-field>
                
                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input matInput matTooltip="The password should contain atleast 1 Upper case, 1 lower case, 1 special symbol and 1 number." [matTooltipPosition]="'left'" placeholder="Set New Password" formControlName="password" type="password" (keypress)="isSpace($event)" minlength="8" maxlength="50" autocomplete="new-password">
                            <mat-error *ngIf="registerForm.controls.password.errors?.required">Password is required
                            </mat-error>
                            <mat-error *ngIf="registerForm.controls.password.errors?.minlength">The password must be atleast 8 characters long.
                            </mat-error>
                            <mat-error class="mb-2" *ngIf="registerForm.controls.password.errors?.pattern">It must contain atleast 1 lowercase, 1 uppercase, 1 number and 1 special character each.
                            </mat-error>
                        </mat-form-field>
                                
                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input matInput matTooltip="The password should contain atleast 1 Upper case, 1 lower case, 1 special symbol and 1 number." [matTooltipPosition]="'left'" placeholder="Confirm Password" formControlName="confirmPassword" type="password" (keypress)="isSpace($event)" maxlength="50">
                            <mat-error *ngIf="registerForm.controls.confirmPassword.errors?.required">Confirm Password is required</mat-error>
                            <mat-error *ngIf="registerForm.hasError('mismatchedPasswords')">
                                Passwords do not match</mat-error>
                            <mat-error class="mb-2" *ngIf="registerForm.controls.confirmPassword.errors?.pattern">It must contain atleast 1 lowercase, 1 uppercase, 1 number and 1 special character each.
                            </mat-error>
                        </mat-form-field>

                        <button mat-raised-button class="mat-elevation-z6 w-100 mt-3 registerBtn" type="submit">Register</button>
                    </div>
                    <div class="NoteDesign" *ngIf="displayMssg == 'case1'">
                        <p class="EventTitle">Note: Students are requested not to register here.</p>
                        <p class="EventbodyText">This page is for Institute registration with official email. Non AICTE Approved Institutions are requested to use only official email and mobile for registration.</p>
                    </div>
                    <div class="NoteDesign" *ngIf="displayMssg == 'case2'">
                        <p class="EventTitle">Note: Incase of any Correction in email or mobile please contact at parakh@aicte-india.org with institute authorized email address.</p>
                        <p class="EventbodyText">Click on "Select Institute Id" and Select your institution. After the verification of email, your institute login account will be activated.</p>
                    </div>
                    <div class="NoteDesign" *ngIf="displayMssg == 'case3'">
                        <p class="EventTitle">Note: Incase of any Correction in email or mobile please contact AISHE.</p>
                        <p class="EventbodyText">Enter AISHE Code and click on "Get details". After verification of the Institute email your institute login account will be activated.</p>
                    </div>
                    <div class="NoteDesign" *ngIf="displayMssg == 'case4'">
                        <p class="EventTitle">Note: Enter your genuine institute details, email and mobile number must be authorized.</p>
                        <p class="EventbodyText">Enter your Details and Submit. After Verification from AICTE, your account will be activated.</p>
                    </div>
                </form>
                
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</section>